module.exports = {
  buttonCreate: 'Create',
  buttonUpdate: 'Update',
  updatePromotion: 'Update External Tool',
  createPromotion: 'Create External Tool',
  title: {
    external: 'External Tools',
    serverHealth: 'Server Health',
  },
  table: {
    title: {
      index: 'INDEX',
      name: 'NAME',
      toolUrl: 'TOOL URL',
      action: 'ACTION',
    },
  },
  tooltip: {
    redirect: 'Open',
    edit: 'Edit',
    delete: 'Delete',
  },
  form: {
    name: 'Name',
    toolUrl: 'Tool Url',
    View: 'View',
  },
  validate: {
    toolUrlBlank: 'Please input Tool Url.',
    name: 'Please input Name.',
  },
  message: {
    updateExternalToolSuccess: 'Updated External Tool successfully.',
    createExternalToolSuccess: 'Created External Tool successfully.',
    deleteExternalToolSuccess: 'Deleted External Tool successfully.',
  },
  popup: {
    title: 'Confirm',
    okBtn: 'Yes',
    cancelBtn: 'No',
    confirmPassword: 'Please input your password to confirm.',
    deleteExternal: 'Are you sure you want to delete this External Tool?',
  },
};
